import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IResponse } from "../Interfaces/Base/IResponse";
import { IVeterinario } from "../Interfaces/Request/Veterinario/IVeterinario";

export interface IVeterinarioAPI {
  fetchAllVeterinarios(): Promise<AxiosResponse<IResponse<IVeterinario[]>>>;
}

class VeterinarioAPI implements IVeterinarioAPI {
  async fetchAllVeterinarios(): Promise<
    AxiosResponse<IResponse<IVeterinario[]>>
  > {
    const axios = await Http.axios();
    const response = axios.get<IResponse<IVeterinario[]>>(
      `/api/user/vet/all-site`
    );
    return response;
  }
}

const instance = new VeterinarioAPI();

export default instance;
